import "./message-box-group.component.scss";

import { memo } from "react";
import { useTranslation } from "react-i18next";

import MessageBox from "components/MessageBox";

import { messageKeyPrefix } from "../../utils/message.util";

const MessageBoxesContainer = props => {
  const { containerMode, children } = props;
  return(
    <>
      { !!containerMode && <div className="message-box-group-container layout-container">{children}</div> }
      { !containerMode && <>{children}</> }
    </>
  )
}

const MessageBoxGroup = props => {
  const { t } = useTranslation();

  const changeSuccessMessage = (message , messagesType="label") => {
    if (message){
      switch (messagesType) {
        case 'sc':
          return t(`${messageKeyPrefix.s.c}${message}`)
        case 'label':
          return message
        case 'i18n':
          return t(message)
        default:
      }
    } else {
      return message
    }
  }

  const changeErrorMessage = (message , messagesType="label") => {
    if (message){
      switch (messagesType) {
        case 'es':
          return t(`${messageKeyPrefix.e.s}${message}`)
        case 'ec':
            return t(`${messageKeyPrefix.e.c}${message}`)
        case 'label':
            return message
        case 'i18n':
              return t(message)
        default:
      }
    } else {
      return message
    }
  }

  const changeWarningMessage = (message , messagesType="label") => {
    if (message){
      switch (messagesType) {
        case 'label':
          return message
        case 'i18n':
          return t(message)
        default:
      }
    } else {
      return message
    }
  }

  const {
    containerMode,
    messages,
    onClose,
    SuccessMessagesType,
    ErrorMessagesType,
    WarningMessagesType,
    ...other
  } = props;
  return (
    <MessageBoxesContainer
      containerMode={containerMode}
    >
      <MessageBox
        show={!!messages.success}
        label= {`${changeSuccessMessage(messages.success, SuccessMessagesType)} `}
        variant='success'
        onClose={() => onClose('success')}
      />
      <MessageBox
        show={!!messages.error}
        label= {`${changeErrorMessage(messages.error, ErrorMessagesType)} `}
        variant='danger'
        onClose={() => onClose('error')}
      />
      <MessageBox
        show={!!messages.warning}
        label={`${changeWarningMessage(messages.warning, WarningMessagesType)} `}
        variant='warning'
        onClose={() => onClose('warning')}
      />
    </MessageBoxesContainer>
  );
};

MessageBoxGroup.defaultProps = {
  containerMode: false
}

export default memo(MessageBoxGroup);


// ==============
// messages object format :
// const messages = {
//   success: null,
//   error: 'xxxxxxx',
//   warning: null,
// };